import { render } from "./AccountsInfoCard.vue?vue&type=template&id=5e58825a"
import script from "./AccountsInfoCard.vue?vue&type=script&lang=js"
export * from "./AccountsInfoCard.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__